var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpDeskAdvisor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2441 18.2207C20.9337 17.1312 19.2659 16.4049 17.598 15.9207C16.4067 15.5575 15.0963 15.3154 13.6667 15.3154C12.3563 15.3154 11.0459 15.5575 9.7354 15.9207C8.06755 16.4049 6.39975 17.2523 5.08929 18.2207C4.49362 18.7049 4.13623 19.4312 4.13623 20.1575V24.9996H23.1972V20.1575C23.1972 19.4312 22.8398 18.7049 22.2441 18.2207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0206 5.14737C9.19929 5.14737 9.3482 5.08682 9.43757 4.96579C10.5395 3.87631 12.0286 3.21053 13.6667 3.21053C16.9428 3.21053 19.6233 5.93422 19.6233 9.26313V10.6553L16.1982 11.8052C16.0493 11.7447 15.9004 11.6842 15.7515 11.6842C15.2452 11.6842 14.858 12.0776 14.858 12.5921C14.858 13.1066 15.2452 13.5 15.7515 13.5C16.1089 13.5 16.4365 13.2881 16.5854 12.9552L21.3209 11.3513C21.5591 11.2605 21.7378 11.0487 21.7378 10.7763V8.05262C21.7378 7.71974 21.4698 7.44735 21.1422 7.44735H20.6061C19.802 4.33028 17.0024 2 13.6667 2C11.7308 2 9.97366 2.78684 8.6632 4.05789C8.5143 4.17893 8.42493 4.33028 8.42493 4.54209C8.42493 4.87502 8.69299 5.14737 9.0206 5.14737Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4021 9.77745C18.4319 9.59587 18.4319 9.44456 18.4319 9.26298C18.4319 6.59984 16.2876 4.4209 13.6667 4.4209C11.0458 4.4209 8.90149 6.59984 8.90149 9.26298C8.90149 11.9262 11.0458 14.1051 13.6667 14.1051C13.756 14.1051 13.8752 14.1051 13.9645 14.0748V12.5919C13.9645 12.3195 14.0241 12.0472 14.1432 11.7748C14.3517 11.3512 14.7091 11.0183 15.1856 10.8669L18.4021 9.77745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpDeskAdvisor);
export default __webpack_public_path__ + "static/media/icon-help-desk-advisor.4c615160f44a446adce52cae0429d372.svg";
export { ForwardRef as ReactComponent };